import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import themeDark from 'assets/theme-dark';
import MDInput from 'components/MDInput';
import CircularProgress from '@mui/material/CircularProgress';
import { Controller, useForm } from "react-hook-form";

import { useMaterialUIController } from "context";

export default function AlertDialog(props) {
  const { onConfirm, onCancel } = props;
  const { handleSubmit, formState: { isSubmitting }, } = useForm();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const handleConfirm = () => {
    return onConfirm();
  }

  const handleCancel = () => {
    onCancel();
  };

  return (
    <MDBox>
      <Dialog
        open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MDBox style={{ backgroundColor: darkMode && themeDark.palette.dark.main }} component="form" role="form" onSubmit={handleSubmit(handleConfirm)}>
          <DialogTitle id="alert-dialog-title">
            Confirmar
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Estás seguro de eliminar este elemento?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MDButton onClick={handleCancel}>No</MDButton>
            <MDButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? <CircularProgress size={18} color="info" /> : 'Si'}
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>
    </MDBox>
  );
}